import { OrderRoutes } from "./OrderRoutes";
import { PaymentRoutes } from "./PaymentRoutes";
export class CheckoutRoutes {
    constructor(config = {}) {
        const basePath = config.isFreeTrial ? "/trial/" : "/";
        this.root = basePath;
        this.shipping = `${this.root}shipping`;
        this.delivery = `${this.root}delivery`;
        this.payment = new PaymentRoutes(basePath);
        this.order = new OrderRoutes(basePath);
    }
}
//# sourceMappingURL=CheckoutRoutes.js.map